module.exports = __webpack_public_path__ + "c7aefe066e4b7bbd81b662c0f8b81e44.pdf";